import React, { useEffect, useState } from 'react';
import { DISCOUNT_UNITS } from '../constants/constants';
import { useSelector } from 'react-redux';
import { cartCurrencySelector, cartTotal } from '../redux/selectors/cartSelector';
import {customRound} from "../lib/customRound";
import SafeHtml from '../components/General/SafeHtml';

function useTotalDiscountPromo(productId, promo) {
    const [productDiscount, setProductDiscount] = useState('-');
    const currency = useSelector((state) => cartCurrencySelector(state));
    const total = useSelector((state) => cartTotal(state, { product_id: productId }));
    const sign = <SafeHtml as={'span'} html={currency?.sign} />;

    useEffect(() => {
        if (total?.discount > 0 && total?.total > 0) {


            let sum = total?.total;

            if (promo && +promo?.product_id === +productId) {
                sum = total?.total * promo.discount /100;
            }

            setProductDiscount(
                <>
                    {customRound(promo?.discount)}
                    {DISCOUNT_UNITS[total?.discount_unit.toUpperCase()]}&nbsp;(
                    {sign}
                    {customRound(sum)})&nbsp;
                </>
            );
        } else {
            setProductDiscount('-');
        }
    }, [total?.total, promo, productId]);

    return productDiscount;
}

export default useTotalDiscountPromo;
